import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isRoHS from "../../../../service/isRoHS"
import isValidSurfaceFinishing from "../../../../service/visibleValidator/isValidSurfaceFinishing"

import RoHSImage from "./RoHS.png"

const RoHSRadio = ({
  value,
  children,
}: {
  value: string
} & JSX.IntrinsicElements["input"]) => (
  <Radio value={value} suffixImageSrc={isRoHS(value) ? RoHSImage : undefined}>
    {children}
  </Radio>
)

const 表面処理 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { surfaceFinishing: shouldShow } = getDisplayCondition(values)

  const showNotes =
    values.surfaceFinishing === ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け無電解ニッケル金めっき.value ||
    values.surfaceFinishing === ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け金めっき.value

  return (
    <OneClickField isShow={shouldShow} legend="表面処理" helpURL={HELP_LINKS.表面処理}>
      <RadioGroup
        name={FIELD_NAMES.表面処理}
        selectedValue={values.surfaceFinishing}
        onChange={handlers.radio}
        shouldRender={(value) => isValidSurfaceFinishing(values, value)}
      >
        <OneClickFieldStack>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["水溶性フラックス(リジッド)"].value}>水溶性フラックス</RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["水溶性フラックス(メタル)"].value}>水溶性フラックス</RoHSRadio>

          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["有鉛はんだレベラー(リジッド)"].value}>
            有鉛はんだレベラー
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["有鉛はんだレベラー(メタル)"].value}>
            有鉛はんだレベラー
          </RoHSRadio>

          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(リジッド)"].value}>
            無鉛はんだレベラー
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(メタル)"].value}>
            無鉛はんだレベラー
          </RoHSRadio>

          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["無電解金フラッシュ(リジッド)"].value}>
            無電解金フラッシュ
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["無電解金フラッシュ(フレキシブル)"].value}>
            無電解金フラッシュ
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["無電解金フラッシュ(メタル)"].value}>
            無電解金フラッシュ
          </RoHSRadio>

          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理.リード無し電解金めっき.value}>リード無し電解金めっき</RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理.ニッケルパラジウム金めっき.value}>
            ニッケルパラジウム金めっき
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け無電解ニッケルパラジウム金めっき.value}>
            ワイヤーボンディング向け{"\n"}無電解ニッケルパラジウム金めっき
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け無電解ニッケル金めっき.value}>
            ワイヤーボンディング向け{"\n"}無電解ニッケル金めっき
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理.ワイヤーボンディング向け金めっき.value}>
            ワイヤーボンディング向け金めっき
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理.錫めっき.value}>錫めっき</RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["しない（銅箔のみ）(リジッド)"].value}>
            しない（銅箔のみ）
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["しない（銅箔のみ）(フレキシブル)"].value}>
            しない（銅箔のみ）
          </RoHSRadio>
          <RoHSRadio value={ESTIMATE_CONSTANT.表面処理["電解金めっき＋水溶性フラックス"].value}>
            電解金めっき＋水溶性フラックス
          </RoHSRadio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.surfaceFinishing}>
        {/* TODO サーバーからエラーを出力するようにして削除する  */}
        {showNotes && <p>※銅箔厚みは「18μm」のみお受付できます。</p>}
      </OneClickFieldMessages>
    </OneClickField>
  )
}

export default 表面処理
